var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, } from 'react';
import classnames from 'classnames';
import styles from './FieldInput.module.scss';
export var FieldInput = forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, hasError = _a.hasError, hasLeadingIcon = _a.hasLeadingIcon, hasTrailingIcon = _a.hasTrailingIcon, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, _c = _a.type, type = _c === void 0 ? 'text' : _c, value = _a.value, props = __rest(_a, ["className", "hasError", "hasLeadingIcon", "hasTrailingIcon", "onBlur", "onChange", "onFocus", "type", "value"]);
    return (React.createElement("input", __assign({}, __assign(__assign({}, props), { className: classnames(styles.input, className, (_b = {},
            _b[styles.hasError] = hasError,
            _b[styles.hasLeadingIcon] = hasLeadingIcon,
            _b[styles.hasTrailingIcon] = hasTrailingIcon,
            _b)), onBlur: onBlur, onChange: onChange, onFocus: onFocus, ref: ref, type: type, value: value }))));
});
//# sourceMappingURL=FieldInput.js.map